import React, { ReactNode } from 'react';
import { FormInput, Label } from '@grubhubprod/gh-cookbook-react';
import { Control, RegisterOptions, useController } from 'react-hook-form';
import { FieldError } from 'react-hook-form/dist/types/errors';
import {
  SelectSearch,
  SelectSearchProps,
} from 'src/components/SelectSearch/SelectSearch';

interface SelectSearchWrapperBaseProps {
  name: string;
  control: Control;
  rules?: RegisterOptions;
  error?: FieldError;
  label?: ReactNode;
}

export type SelectSearchWrapperProps<T, M> = SelectSearchWrapperBaseProps &
  Omit<SelectSearchProps<T, M>, 'error'>;

export function SelectSearchWrapper<T, M>({
  name,
  control,
  rules = {},
  error,
  label,
  ...selectSearchProps
}: SelectSearchWrapperProps<T, M>): JSX.Element {
  useController({
    name,
    rules,
    control,
    defaultValue: control.defaultValuesRef.current[name] ?? null,
  });

  return (
    <FormInput inputSize={selectSearchProps.inputSize} error={error}>
      {label && <Label>{label}</Label>}
      <SelectSearch<T, M> {...selectSearchProps} error={!!error} />
    </FormInput>
  );
}
